import { render, staticRenderFns } from "./industryTrendsList.vue?vue&type=template&id=50c6720a&scoped=true&"
import script from "./industryTrendsList.vue?vue&type=script&lang=js&"
export * from "./industryTrendsList.vue?vue&type=script&lang=js&"
import style0 from "./industryTrendsList.vue?vue&type=style&index=0&id=50c6720a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c6720a",
  null
  
)

export default component.exports